module.exports = __webpack_public_path__ + "img/device_point4.9fc9d8c2.png";